import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "go-app/components/Header";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { CustomFieldTemplateApi } from "go-segment/services/types";
import { api } from "../../../../../../../../../../services/Api/api";
import ProductCategoryForm from "../../components/ProductCategoryForm";

const OrganizationProductCategoriesNewPage = () => {
	const [customFields, setCustomFields] = useState<CustomFieldTemplateApi[]>([]);
	const { t } = useTranslation();
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		handleChangeTabTitle(t("modules.product_category.header.new.title"));

		const getCFConfig = async () => {
			const params: Record<string, any> = {
				resource_name: "PRODUCT_CATEGORY",
				custom_field_resource_type: "PRODUCT_CATEGORY",
			};
			const res = await api.organization().getResourceTypes(params);
			setCustomFields(res.custom_fields);
		};
		getCFConfig();
	}, []);

	if (!customFields) return <LoadingContainer />;

	return (
		<>
			<Header title={t("modules.product_category.header.new.title")} />
			<ProductCategoryForm customFieldsConfig={customFields} />
		</>
	);
};

export default OrganizationProductCategoriesNewPage;
